module.exports = __webpack_public_path__ + "media/THE 4 imagination_mobile.2dab2678.mp4";